<template>
  <div class="quick_sales">
    <div class="header">车家·Quick Sales</div>
    <!-- 搜索 -->
    <div class="search">
      <input type="text" class="search_ipt" placeholder="请输入ID" maxlength="50" v-model.trim="crmld">
      <button class="search_btn" @click="handleClickSearch" :disabled="isDisabled">搜索</button>
    </div>

    <!--填报人 -->
    <div class="filled_by">
      <div class="search_result_title">填报人</div>
      <div class="filled_by_info">
        <div class="filled_by_left"><span class="required">*</span> 填报人： </div>
        <div class="filled_by_right">
          <van-field readonly clickable :value="filledBy" placeholder="请选择" @click="showPickerFilledBy = true" />
          <van-popup v-model="showPickerFilledBy" round position="bottom">
            <van-picker show-toolbar :columns="columnsFilledBy" value-key="fullName" @cancel="showPickerFilledBy = false" @confirm="onConfirmFilledBy" />
          </van-popup>
          <img src="../../assets/image/QuickSales/down.png" alt="" class="sel_down">
        </div>
      </div>
    </div>

    <div class="block">

    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import qs from 'qs';
export default {
  data() {
    return {
      columnsFilledBy: [],
      showPickerTime: false,
      filledBy: '', //填报人
      showPickerFilledBy: false, //填报人picker
      crmld: '', //搜索内容 '201710250064444 '2018021900878330' '2020062908195220' '2021101508308937'
      isDisabled: false, //禁止按钮
      codeState: null,
    };
  },
  mounted() {
    this.filledBy = this.$route.query && this.$route.query.filledBy;

    this.reqUsers();
  },

  methods: {
    // 填报人:
    onConfirmFilledBy(value) {
      this.filledBy = value.fullName;
      sessionStorage.setItem('crmQslatestsalesC', this.filledBy);
      this.showPickerFilledBy = false;
    },
    //搜索
    async handleClickSearch() {
      const { crmld } = this;
      if (!crmld) return Toast('请输入id');
      try {
        const result = await this.$axios.post(
          '/crm/quickSales/queryAccounts',
          qs.stringify({ crmIdC: crmld })
        );
        if (result.data.code === 0) {
          if (result.data.data == null) {
            Toast(result.data.msg);
            return;
          }
          sessionStorage.setItem('searchValue', crmld);
          this.$router.push('/quick_sales_info');
        } else if (result.data.code === 1) {
          Toast(result.data.msg);
        }
      } catch (error) {
        Toast(error.data.msg);
      }
    },
    async reqUsers() {
      try {
        const result = await this.$axios.post('/crm/quickSales/queryUsers');
        if (result.data.code === 0) {
          this.columnsFilledBy = result.data.data;
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-popup--bottom {
  position: fixed;
  width: 7.5rem;
  left: 50%;
  margin-left: -3.75rem;
}
/deep/.van-cell {
  background: #eff5ff;
  padding: 0;
  .van-field__control {
    font-size: 0.28rem !important;
  }
}
.quick_sales {
  margin: 0 auto;
  max-width: 7.5rem;
  box-shadow: 2px 2px 25px 0 rgba(0, 0, 0, 0.1);
  height: 100vh;
  .header {
    font-size: 0.36rem;
    color: #222222;
    text-align: center;
    line-height: 0.88rem;
    height: 0.88rem;
    border-bottom: 0.01rem solid #f1f1f1;
    font-weight: 600;
  }

  // 搜索
  .search {
    margin: 0.19rem 0.35rem 0.39rem;
    display: flex;
    justify-content: space-between;
    .search_ipt {
      width: 4.98rem;
      height: 0.78rem;
      background: #fafdff;
      border: 0.01rem solid #3289ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      padding-left: 0.25rem;
      box-sizing: border-box;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #333333;
      line-height: 0.26rem;
    }
    .search_btn {
      width: 1.62rem;
      height: 0.78rem;
      background: #3289ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      border: none;
      font-family: PingFangSC-Medium;
      font-size: 0.26rem;
      color: #ffffff;
      text-align: center;
      line-height: 0.38rem;
    }
    .search_btn:hover {
      cursor: pointer;
    }
  }

  // 填报人
  .filled_by {
    .search_result_title {
      font-size: 0.24rem;
      color: #888888;
      margin-left: 0.35rem;
    }
    .filled_by_info {
      height: 1.16rem;
      width: 6.8rem;
      background: #eff5ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      margin: 0.08rem 0.35rem 0.25rem;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      .filled_by_left {
        width: 2.37rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
        font-size: 0.28rem;
        color: #151515;
      }
      .filled_by_right {
        width: 4.43rem;
        display: flex;
        padding-right: 0.25rem;
        box-sizing: border-box;
        height: 100%;
        align-items: center;
        font-size: 0.28rem;
        color: #333333;
        position: relative;
      }

      /deep/.van-cell {
        .van-field__value {
          .van-field__body {
            .van-field__control {
              height: 1.16rem;
              background: #eff5ff;
            }
          }
        }
      }
    }
  }
  .required {
    font-size: 0.28rem;
    color: #c82a18;
  }
  .sel_down {
    position: absolute;
    right: 0.25rem;
    pointer-events: none;
    width: 0.2rem;
    height: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuickSales/QuickSales.vue